import { Module } from "vuex";
import { RootState } from "@/store";

import state, { DashboardState } from "./state";
import mutations from "./mutations";
import actions from "./actions";

export default {
    state,
    mutations,
    actions,
} as Module<DashboardState, RootState>;
